import localforage from "localforage";
import { authLogout } from "../apis/logoutAPI";
import { toast } from "@/helpers/toast";
import { setToken } from "../apis/getToken";
import { APP_ENV } from "@/APP_ENV";
import { getMaintainDomain } from "./utils";

// 加载维护站点的js，能加载就说明处于维护状态
export function checkIsMaintationStatus() {
  return new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.onload = resolve;
    script.onerror = reject;
    script.src = `${getMaintainDomain()}/check.js`;
    document.head.appendChild(script);
  });
}

export const errorHandling = (
  error,
  shouldRedirect = true,
  needTranslation = false,
  t
) => {
  if (!error) {
    return toast.error("Unknown Error");
  }
  // compat for jQuery ajax error handler
  if (error.responseJSON && !error.response) {
    error.response = {
      data: error.responseJSON,
      status: error.status
    };
  }

  if (!error.response) {
    toast.error(error.message || "Request Error");
    return;
  }

  let errorObject = error.response.data;

  if (!errorObject) {
    toast.error("Request Error");
    return;
  }

  if (errorObject) {
    if (typeof errorObject === "object" && !errorObject.message) {
      errorObject.message = "Already logout on other page";
    }
    let status = error.response.status;
    let httpCodes = [400, 401, 403, 422, 502, 504, 404, 500, 503];
    if (status === 499) {
      toast.alert(errorObject.message, {
        afterClose: () => {
          authLogout();
        }
      });
    } else if (status === httpCodes[3]) {
      const errors = errorObject?.errors || errorObject?.message?.errors;
      if (errors) {
        for (let objs in errors) {
          errors[objs].forEach(errMsg => {
            toast.error(needTranslation ? `${t(`error.${errMsg}`)}` : errMsg);
          });
        }
      }
    } else if (status === httpCodes[1]) {
      if (shouldRedirect === true) {
        setToken(null);
        // localforage.clear().then(() => {
        //   window.location.replace("/login");
        // });
        authLogout();
      } else {
        toast.error(errorObject.message);
      }
    } else if (status === httpCodes[4]) {
      // 如果服务502，去检查platform是否处于维护状态
      checkIsMaintationStatus().then(() => {
        const lang = localStorage.getItem("rcml-lang");
        window.location.href = getMaintainDomain() + "/?lang=" + lang;
      });
    } else if (status === httpCodes[5]) {
      toast.error(errorObject.message || "Gateway Timeout");
    } else if (status === httpCodes[6]) {
      toast.error(errorObject.message || "404 Not Found");
    } else if (status === httpCodes[7]) {
      toast.error(errorObject.message || "Internal Server Error");
    } else if (status === httpCodes[8]) {
      toast.error(errorObject.message || "Service Unavailable");
    } else {
      toast.error(errorObject.message);
    }
  } else {
    toast.error(errorObject.message);
  }
};
